<script setup>
defineProps({
  location: {
    type: Object,
    default: null,
  },
});
</script>

<template>
  <Card
    :card-class-names="$style.container"
    :has-body-padding-small="true"
  >
    <template #header>
      <h2 class="section-title heading-color">
        Snow Forecast Summary
      </h2>
    </template>
    <template #body>
      <div
        :class="[
          'tw-mb-4 lg:tw-mb-2.5',
          $style.watermark,
        ]"
      >
        <Snow10DayForecastSummary
          :is-compare="false"
          :location="location"
          :mobile-date-long-wrap="true"
        />
      </div>
      <SnowForecastTableFooter
        field="forecast_snow_daily"
        :source-id="location.forecast_source_id"
      />
    </template>
  </Card>
</template>

<style module>
.container {
   --watermark-image: url('https://blizzard.opensnow.com/logos/logo-opensnow-app-text-only-light.png');
 }

 :global([data-theme="dark"]) .container {
   --watermark-image: url('https://blizzard.opensnow.com/logos/logo-opensnow-app-text-only-dark.png');
 }

.watermark {
  /*
  * Use linear gradient to change opacity of background image
  * SEE: https://stackoverflow.com/questions/4997493/set-opacity-of-background-image-without-affecting-child-elements
  */
  background-image:
    linear-gradient(rgb(var(--card-background-rgb) / 95%), rgb(var(--card-background-rgb) / 95%)),
    var(--watermark-image)
  ;
  background-position: center 40%;
  background-repeat: no-repeat;
  background-size: 90%;
}

@media (min-width: 768px) {
  .watermark {
    background-position: 50% 5%;
    background-size: 70%;
  }
}
</style>
